var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2-Food equipment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2-Food_equipment",
    "data-name": "2-Food equipment"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,15a5.006,5.006,0,0,1-5-5V0h2V10a3,3,0,0,0,6,0V0h2V10A5.006,5.006,0,0,1,13,15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 2,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,48H11a1,1,0,0,1-1-1V26a3,3,0,0,1,6,0V47A1,1,0,0,1,15,48Zm-3-2h2V26a1,1,0,0,0-2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,48H22a1,1,0,0,1-1-1V31a3,3,0,0,1,6,0V47A1,1,0,0,1,26,48Zm-3-2h2V31a1,1,0,0,0-2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,29H24V25.6l-1.757-.94A5.807,5.807,0,0,1,19.114,18.4l2.75-16.656A2.082,2.082,0,0,1,26,2.082ZM23.918,2a.082.082,0,0,0-.081.067l-2.757,16.7A3.787,3.787,0,0,0,23.187,22.9l.813.435V2.082A.082.082,0,0,0,23.918,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 14,
    width: 2,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,48H32a1,1,0,0,1-1-1V26a3,3,0,0,1,6,0V47A1,1,0,0,1,36,48Zm-3-2h2V26a1,1,0,0,0-2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,16c-3.309,0-6-3.589-6-8s2.691-8,6-8,6,3.589,6,8S37.309,16,34,16ZM34,2c-2.168,0-4,2.748-4,6s1.832,6,4,6,4-2.748,4-6S36.168,2,34,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,42H6a6.006,6.006,0,0,1-6-6V12A6.006,6.006,0,0,1,6,6V8a4,4,0,0,0-4,4V36a4,4,0,0,0,4,4H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,42H39V40h3a4,4,0,0,0,4-4V12a4,4,0,0,0-4-4V6a6.006,6.006,0,0,1,6,6V36A6.006,6.006,0,0,1,42,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,38H6a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2v2H6V36H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,38H39V36h3V10a2,2,0,0,1,2,2V36A2,2,0,0,1,42,38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 36,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 40,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 36,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 40,
    width: 3,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodIcon);
export default __webpack_public_path__ + "static/media/foodIcon.b5e94f0554e5f25caa6a20982d877a40.svg";
export { ForwardRef as ReactComponent };